import { createApi } from '@reduxjs/toolkit/query/react';
import { isUndefined } from 'lodash';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const wikiApi = createApi({
  reducerPath: 'wikiApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    saveWikiPage: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: `${urls.wikiPageDetail(req.id)}`,
            method: 'PUT',
            data: req,
          };
        } else {
          return {
            url: `${urls.wikiPages}`,
            method: 'POST',
            data: req,
          };
        }
      },
    }),
    getWikiPages: builder.query({
      query: () => ({
        url: urls.wikiPages,
      }),
    }),
    getWikiCategories: builder.query({
      query: () => ({
        url: urls.wikiCategories,
      }),
    }),
    getWikiCategoryItem: builder.query({
      query: (id) => ({
        url: isUndefined(id) ? null : urls.wikiCategoryDetail(id),
      }),
    }),
    saveWikiCategory: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: `${urls.wikiCategoryDetail(req.id)}`,
            method: 'PUT',
            data: req,
          };
        } else {
          return {
            url: `${urls.wikiCategories}`,
            method: 'POST',
            data: req,
          };
        }
      },
    }),
    deleteWikiCategoryItem: builder.mutation({
      query: (id) => ({
        url: urls.wikiCategoryDetail(id),
        method: 'DELETE',
      }),
    }),
    getWikiPageItem: builder.query({
      query: (id) => ({
        url: isUndefined(id) ? null : urls.wikiPageDetail(id),
      }),
    }),
    deleteWikiPageItem: builder.mutation({
      query: (id) => ({
        url: `${urls.wikiPages}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useSaveWikiPageMutation,
  useGetWikiPagesQuery,
  useGetWikiCategoriesQuery,
  useGetWikiCategoryItemQuery,
  useSaveWikiCategoryMutation,
  useDeleteWikiCategoryItemMutation,
  useGetWikiPageItemQuery,
  useDeleteWikiPageItemMutation,
} = wikiApi;
